import type { MfeConfig } from './types';
import type { AppSettings } from '../types';

/**
 * Get MFE Settings for the Search+match application
 * @param appSettings
 * @param config
 * @returns
 */
export function getModuleFederationConfig(
  appSettings: AppSettings,
  config: any
): MfeConfig {
  const conf: MfeConfig = {};
  const mfeSettings = appSettings?.MICRO_FRONT_ENDS || {};
  Object.keys(mfeSettings).forEach((key) => {
    const { urlTemplate } = mfeSettings[key];
    conf[key] = {
      urlTemplate: urlTemplate,
      version: config?.mfe_versions?.[key]
    };
  });
  return conf;
}
